<template >
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout
            :meun="meunItem"
            :title="meunTitle"
            :title2="meunTitle2"
          ></headerLayout>
        </el-header>
        <el-main class="main">
          <div class="mainbody">
            <h3 class="title">提交资料</h3>
            <div class="aLine"></div>
            <div class="infobody">
              <div class="name">{{ info.name }}</div>
              <!-- <p class="name">{{ info.name }}</p> -->
              <!-- <div class="info_div">
                <span>手机号：</span>
                <span>{{ info.mobile }}</span>
              </div>
              <div class="info_div">
                <span>身份证号：</span>
                <span>{{ info.id_card_number }}</span>
              </div> -->
              <!-- <div style="clear: both"></div>
              <div class="info_div">
                <span>在校经历：</span>
                <span>{{ info.experience }}</span>
              </div>
              <div class="info_div">
                <span>学部：</span>
                <span>{{ info.division }}</span>
              </div>
              <div style="clear: both"></div>
              <div class="info_div">
                <span>在校时间：</span>
                <span>{{ info.schoolTime }}</span>
              </div>
              <div class="info_div">
                <span>专业：</span>
                <span>{{ info.programme }}</span>
              </div> -->
              <div style="clear: both"></div>
              <div
                class="boxInfo"
                v-for="(info, index) in data_list"
                :key="info.id"
              >
                <h3 class="title">
                  第 {{ data_list.length - index }} 次提交资料
                  {{ info.createTime }}
                </h3>
                <div class="aLine"></div>
                <div class="experience">
                  <p class="title1">深造</p>
                  <div class="info_div">
                    <span>所在地：</span>
                    <span>{{ info.education_ }}</span>
                  </div>
                  <div class="info_div">
                    <span>院校名称：</span>
                    <span>{{ info.education_school }}</span>
                  </div>
                  <div class="info_div">
                    <span>院校专业：</span>
                    <span>{{ info.education_programme }}</span>
                  </div>
                  <div style="clear: both"></div>
                  <div class="info_div">
                    <span>进修学位：</span>
                    <span>{{ info.education_status }}</span>
                  </div>
                  <div class="info_div">
                    <span>毕业年份：</span>
                    <span>{{ info.education_graduation_year }}</span>
                  </div>
                  <div class="info_div">
                    <span>其他：</span>
                    <span>{{ info.education_other }}</span>
                  </div>
                  <div style="clear: both"></div>
                  <!-- <div class="info_div" style="width: 550px">
                    <span>该数据更新时间：</span>
                    <span>{{ info.createTime }}</span>
                  </div>
                  <div style="clear: both"></div> -->
                  <div class="aLine"></div>
                  <p class="title1" style="margin-top: 16px">
                    {{ info.job_status }}
                  </p>
                  <div class="info_div">
                    <span>所在地：</span>
                    <span>{{ info.organization_ }}</span>
                  </div>
                  <div class="info_div">
                    <span>单位名称：</span>
                    <span>{{ info.organization }}</span>
                  </div>
                  <div class="info_div">
                    <span>单位性质：</span>
                    <span>{{ info.unit_property }}</span>
                  </div>
                  <div style="clear: both"></div>
                  <div class="info_div">
                    <span>行业类型：</span>
                    <span>{{ info.job_type }}</span>
                  </div>
                  <div class="info_div">
                    <span>公司注册地：</span>
                    <span>{{ info.registered_address }}</span>
                  </div>
                  <div class="info_div">
                    <span>雇员人数：</span>
                    <span>{{ info.employees }}</span>
                  </div>
                  <div style="clear: both"></div>
                  <div class="info_div">
                    <span>年营业额：</span>
                    <span>{{ info.turnover }}</span>
                  </div>
                  <div class="info_div">
                    <span>工作职位：</span>
                    <span>{{ info.position }}</span>
                  </div>
                  <div class="info_div">
                    <span>薪酬范围：</span>
                    <span>{{ info.pay }}</span>
                  </div>
                  <div class="info_div">
                    <span>从事何种自由职业：</span>
                    <span>{{ info.freelance }}</span>
                  </div>
                  <div style="clear: both"></div>
                  <!-- <div class="info_div" style="width: 550px">
                    <span>该数据更新时间：</span>
                    <span>{{ info.createTime }}</span>
                  </div>
                  <div style="clear: both"></div> -->
                </div>
              </div>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import * as Utils from "@/utils/utils.js";
import * as StrUtils from "@/utils/strUtils.js";
import * as CApi from "@/api/constant_api.js";
import * as Api from "@/api/api.js";
import { URL_PATH } from "@/config/config";
import leftMeun from "@/components/layout/leftMeun";
import headRight from "@/components/layout/headRight";
import headerLayout from "@/components/layout/headerLayout";

export default {
  components: {
    leftMeun,
    headRight,
    headerLayout,
  },
  data() {
    return {
      urlPath: URL_PATH,
      meunItem: null,
      meunTitle: "",
      meunTitle2: "认证详情页",
      info: { year: {} },
      data_list: [],
    };
  },
  methods: {
    initData(meunItem) {
      this.meunItem = meunItem;
      this.meunTitle = this.meunItem.name;
      this.getInfo();
    },
    getInfo: function () {
      this.$api
        .activationInfo({
          token: localStorage.getItem("token"),
          wx_openid: this.$route.query.wx_openid,
        })
        .then(({ data }) => {
          this.data_list = data.Data;
          this.info = this.data_list[1];
          this.data_list.forEach((info) => {
            info.createTime = Utils.dateFormat1(info.create_time * 1000);
            // if (info.year) {
            //   info.schoolTime = info.year.start + "-" + info.year.end;
            // }
            // info.createTime = Utils.dateFormat(info.create_time * 1000);
            info.education_ = this.getEducation_(info);
            info.organization_ = this.getOrganization_(info);

            info.mobile = this.reValue(info.mobile);
            info.experience = this.reValue(info.experience);
            info.education_school = this.reValue(info.education_school);
            info.education_programme = this.reValue(info.education_programme);
            info.division = this.reValue(info.division);
            // info.schoolTime = this.reValue(info.schoolTime);
            info.programme = this.reValue(info.programme);
            info.education_ = this.reValue(info.education_);
            info.education_status = this.reValue(info.education_status);
            info.education_graduation_year = this.reValue(
              info.education_graduation_year
            );
            info.education_other = this.reValue(info.education_other);
            // info.createTime = this.reValue(info.createTime);
            info.organization_ = this.reValue(info.organization_);
            info.organization = this.reValue(info.organization);
            info.unit_property = this.reValue(info.unit_property);
            info.job_type = this.reValue(info.job_type);
            info.registered_address = this.reValue(info.registered_address);
            info.employees = this.reValue(info.employees);
            info.turnover = this.reValue(info.turnover);
            info.freelance = this.reValue(info.freelance);
            info.position = this.reValue(info.position);
            info.pay = this.reValue(info.pay);
          });
          this.data_list.reverse();
        })
        .catch(({ error }) => {});
    },
    getEducation_(info) {
      let str = "";
      if (info.education_nation) str = str + info.education_nation + " ";
      if (info.education_province) str = str + info.education_province + " ";
      if (info.education_city) str = str + info.education_city;
      return str;
    },
    getOrganization_(info) {
      let str = "";
      if (info.organization_nation) str = str + info.organization_nation + " ";
      if (info.organization_province)
        str = str + info.organization_province + " ";
      if (info.organization_city) str = str + info.organization_city;
      return str;
    },
    // 显示字段
    reValue(value) {
      value = StrUtils.isEmpty(value) ? "未填写" : value;
      return value;
    },
  },
};
</script>

<style lang="less" scoped>
.mainbody {
  // overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
  padding-bottom: 58px;
}
.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  padding: 16px 32px;
}
.mainbody .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.infobody {
  margin: 32px;
}
.infobody .name {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  margin-bottom: 18px;
}
.infobody .info_div {
  width: 350px;
  float: left;
  margin-bottom: 8px;
}
.infobody .info_div span {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #595959;
}
.mainbody .boxInfo {
  margin-bottom: 24px;
  border: 1px solid #e9e9e9;
  box-sizing: border-box;
}
.mainbody .boxInfo .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  padding: 11px 24px;
  background: #fafafa;
  // border: 1px solid #e9e9e9;
  box-sizing: border-box;
}
.mainbody .boxInfo .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.boxInfo .experience {
  padding: 16px 24px;
}
.boxInfo .experience .title1 {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #595959;
  margin-bottom: 12px;
}
.experience .info_div {
  width: 280px;
  float: left;
  margin-bottom: 8px;
}
.mainbody .tableInfo {
  box-sizing: border-box;
  margin-left: 32px;
  margin-right: 32px;
}
</style>


// WEBPACK FOOTER //
// src/pages/wxapp/authActivationDetails.vue